import AuthLayout          from '@widesk-ui/layouts/AuthLayout';
import { AuthLayoutProps } from '@widesk-ui/layouts/AuthLayout';
import useIsMobile         from '@/hooks/useIsMobile';
import { MenuOutlined }    from '@ant-design/icons';

/** Sur mobile, la navigation disparaît entièrement une fois repliée : antd affiche alors son propre bouton d'ouverture. */
export default function AppAuthLayout(props: AuthLayoutProps) {
	const isMobile = useIsMobile();

	return (
		<AuthLayout
			{...props}
			siderCollapsedWidth={isMobile ? 0 : props.siderCollapsedWidth}
			siderTrigger={isMobile ? <MenuOutlined /> : props.siderTrigger}
		/>
	);
}
